// ScrollToTop.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Add slight delay to ensure DOM is ready
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "instant" // or "smooth" for smooth scrolling
      });
    }, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;